module.exports = __webpack_public_path__ + "static/armenia-6e8255711adf5c532e98761513870db1.jpg";